import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../data/fields';
import InputComponent from '../components/elements/input';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import HeaderComponent from '../components/table/header/headerComponent';
import DropZoneComponent from '../components/dropzone';
import TextArea from '../components/elements/textArea';
import ManufacturersAction from '../app/store/actions/manufacturers';
import VALIDATOR from '../helpers/validator/formValidator';

import randomPassword from '../helpers/generator';

// const helper = '';
class ManufacturersForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      name: '',
      description: '',
      redirectUrl: '',
      imageUrl: '',
      message: '',
      success: '',
      active: true,
      loadImage: false,
      file: '',
      isUpdate: false,
    };
  }

  async componentDidMount() {
    if (this.props.location.search) {
      const { search } = this.props.location;
      const splited = search.split('=');
      const id = splited[1];
      await this.props.getManufacturer(id);
      const {
        description, imageUrl, name, redirectUrl, active,
      } = this.props.manufacturer;
      await this.setState({
        id, description, imageUrl, name, redirectUrl, active, isUpdate: true,
      });
    }
  }

  goBack = () => {
    history.push(ROUTES.MANUFACTURERS);
  }

  uploadedFile = async (file, id) => {
    if (!file) {
      this.setState({ message: I18n.t('selectImage'), success: '' });
    } else {
      try {
        await this.setState({ loadImage: true });
        const hash = randomPassword();
        const extension = file[0].name.split('.').pop();
        const opico = this.props.settings.name;
        const name = `${opico}${hash}.${extension}`;
        const img = await ManufacturersAction.uploadManufacturer(file[0], name, id);
        return img.name;
      } catch (err) {
        await this.setState({ message: I18n.t('invalidImageFormat'), success: '' });
      } finally {
        await this.setState({ loadImage: false });
      }
    }
  }

  createManufacturer = async () => {
    const {
      name, description, redirectUrl, file,
    } = this.state;

    const imageUrl = await this.uploadedFile(file);

    if (imageUrl) {
      const valid = VALIDATOR.ManufacturerValidator({ name, description });
      if (valid.success) {
        await this.props.createManufacturer({
          name, description, imageUrl, redirectUrl, active: true,
        });
        await this.setState({
          message: '',
          success: I18n.t('manufacturerCreated'),
          id: '',
          name: '',
          description: '',
          redirectUrl: '',
          imageUrl: '',
          active: true,
          file: '',
        });
      } else {
        await this.setState({ message: valid.message, success: '' });
      }
    }
  }

  updateManufacturer = async () => {
    const {
      name, description, redirectUrl, id, active, file,
    } = this.state;
    let image;
    if (file) {
      image = await this.uploadedFile(file, id);
    }

    const valid = VALIDATOR.ManufacturerValidator({ name, description });
    if (valid.success) {
      await this.props.updateManufacturer({
        name, description, imageUrl: image, redirectUrl, active, id,
      });
      await this.setState({ message: '', success: I18n.t('manufacturerUpdated') });
    } else {
      await this.setState({ message: valid.message, success: '' });
    }
  }

  render() {
    const {
      name,
      description,
      /* redirectUrl, */
      imageUrl,
      id,
      message,
      success,
      loadImage,
      isUpdate,
      file,
    } = this.state;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('manufacturerRegister')}
        />
        <div className="justify-content-center display-flex">
          {isUpdate
          && (
          <img
            src={imageUrl || 'images/default-image.jpg'}
            className="img-logo-manufacturers"
            alt="Logo"
          />
          )
          }
        </div>
        <div className="row margin-bottom-20 manufacturer-form-div justify-content-center">

          <div className="dropzone-out">
            <DropZoneComponent
              uploadedFile={e => this.setState({ file: e, success: '', message: '' })}
              title={I18n.t('dragManufacturer')}
              loadImage={loadImage}
              fileName={file && file[0].name}
            />
          </div>
        </div>
        <div className="form-group search-custom-input">
          <p className="margin-bottom-2"><Translate value="name" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ name: e.target.value })}
            value={name}
            maxLength={FIELDS.max}
          />
          {/* <p className="margin-bottom-2"><Translate value="urlToRedirect" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ redirectUrl: e.target.value })}
            value={redirectUrl}
            maxLength={FIELDS.max}
          /> */}
          <TextArea
            title={I18n.t('description')}
            onChange={e => this.setState({ description: e.target.value })}
            value={description}
            maxLength=""
            placeHolder=""
            rows={3}
          />
          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id
            ? (
              <button
                type="button"
                className="btn btn-dark margin"
                onClick={this.updateManufacturer}
              >
                <Translate value="update" />
              </button>
            )
            : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.createManufacturer}
              >
                <Translate value="register" />
              </button>
            )
          }
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getManufacturer: id => dispatch(ManufacturersAction.getManufacturer(id)),
  updateManufacturer: manufacturer => dispatch(ManufacturersAction.updateManufacturer(manufacturer)),
  createManufacturer: manufacturer => dispatch(ManufacturersAction.createManufacturer(manufacturer)),
});

const mapStateToProps = state => ({
  manufacturer: state.manufacturers && state.manufacturers.manufacturer,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(ManufacturersForm);
